module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAABGdBTUEAALGPC/xhBQAAAQpJREFUWAntWNEJwkAM7Ym4QsEF/O0IHaP9cgbRPVzBkfx1gAqOoB+eL1ClHOHSM2cVTCBwSS7J62sgcEWhFO99A+16bZTldOkAUUKv0KfQudRUnWmSkbuCLgY16Ey+t0ULiMvnfKMBqpJHd0m4aIAksowhY0hiQIrbDBlDEgNSfE4X+g1NSzF1piqmQYV6jDvquiN6cs5dHJJbGAfocGvDnFxu6LgmQB0Oy8nb8w3Pqb+IL5PRS4B2UKLr20IYto5QKId6H3zJBvYx8Enma6ili9E4PqSGhlJHk4TgT86QgHnasDEk8W0MGUMSA1LcZujvGKKlGArnC+98xsZWzf5gpUYKUC0025PeA82JgGZMg2erAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/upload@2x.png
// module id = DmlL
// module chunks = 1